import { createStore } from "vuex";
import editor from "./editor.js";
import viewer from "./viewer.js";
import results from "./results.js";
const store = createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    editor,
    viewer,
    results
  },
  plugins: []
});
export {
  store as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdG9yZS9pbmRleC50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjcmVhdGVTdG9yZSB9IGZyb20gXCJ2dWV4XCI7XG5pbXBvcnQgZWRpdG9yIGZyb20gXCIuL2VkaXRvclwiO1xuaW1wb3J0IHZpZXdlciBmcm9tIFwiLi92aWV3ZXJcIjtcbmltcG9ydCByZXN1bHRzIGZyb20gXCIuL3Jlc3VsdHNcIjtcblxuZXhwb3J0IGRlZmF1bHQgY3JlYXRlU3RvcmUoe1xuICBzdGF0ZToge30sXG4gIGdldHRlcnM6IHt9LFxuICBtdXRhdGlvbnM6IHt9LFxuICBhY3Rpb25zOiB7fSxcbiAgbW9kdWxlczoge1xuICAgIGVkaXRvcixcbiAgICB2aWV3ZXIsXG4gICAgcmVzdWx0c1xuICB9LFxuICBwbHVnaW5zOiBbXSxcbn0pO1xuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7QUFLQSxNQUFBLFFBQWUsWUFBWTtBQUFBLEVBQ3pCLE9BQU8sQ0FBQztBQUFBLEVBQ1IsU0FBUyxDQUFDO0FBQUEsRUFDVixXQUFXLENBQUM7QUFBQSxFQUNaLFNBQVMsQ0FBQztBQUFBLEVBQ1YsU0FBUztBQUFBLElBQ1A7QUFBQSxJQUNBO0FBQUEsSUFDQTtBQUFBLEVBQ0Y7QUFBQSxFQUNBLFNBQVMsQ0FBQTtBQUNYLENBQUM7In0=
